<template>
  <div class="card">
    <div class="card-header bg-white">
      <h5 class="card-title mb-0">Order Summary</h5>
    </div>
    <div class="card-body">
      <div class="d-flex justify-content-between mb-2">
        <span>Items</span>
        <span>${{ pricing.grandSubtotal.toFixed(2) }}</span>
      </div>
      <div class="d-flex justify-content-between mb-2">
        <span>Shipping<span v-if="pricing.sellerGroups.length > 1" class="text-muted"> ({{ pricing.sellerGroups.length }} boxes)</span></span>
        <span>${{ pricing.grandShipping.toFixed(2) }}</span>
      </div>
      <!-- Tax depends on the ship-to state, which the cart doesn't know; "$0.00" was wrong for
           New Jersey buyers. -->
      <div class="d-flex justify-content-between mb-2 text-muted">
        <span>Tax</span>
        <span v-if="pricing.grandTax > 0">${{ pricing.grandTax.toFixed(2) }}</span>
        <span v-else>at checkout, if any</span>
      </div>
      <!-- First-order credit (2026-10-15): set by the page for visitors who haven't bought. An
           estimate here; checkout confirms it once it knows who's buying. -->
      <div v-if="credit > 0" class="d-flex justify-content-between mb-2 text-success">
        <span>First-order credit<span class="d-block small text-muted">applied at checkout</span></span>
        <span>-${{ credit.toFixed(2) }}</span>
      </div>
      <div v-else-if="shortBy > 0" class="small mb-2 p-2" style="background:#fff8e8;color:#7a5208;border-radius:6px;">
        Add ${{ shortBy.toFixed(2) }} more to get $10 off your first order.
      </div>
      <hr />
      <div class="d-flex justify-content-between mb-3">
        <strong>Total</strong>
        <strong class="h5 mb-0">${{ total.toFixed(2) }}</strong>
      </div>
      <a
        href="/checkout"
        class="btn btn-primary btn-lg btn-block"
        :class="{ disabled: hasUnavailable }"
        :tabindex="hasUnavailable ? -1 : 0"
      >
        Checkout &middot; ${{ total.toFixed(2) }}
      </a>
      <div v-if="hasUnavailable" class="text-danger text-center mt-2 small">
        Remove unavailable items to continue
      </div>
      <div class="text-center mt-3">
        <a href="/" class="text-muted small">Continue shopping</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pricing: Object,
    hasUnavailable: Boolean
  },
  computed: {
    offer: function () { return window.__FIRST_ORDER_CREDIT__ || null; },
    delivered: function () { return this.pricing.grandSubtotal + this.pricing.grandShipping; },
    credit: function () {
      if (!this.offer || this.delivered < this.offer.minimum) return 0;
      return Math.max(0, Math.min(this.offer.amount, this.pricing.grandTotal - 0.5));
    },
    shortBy: function () {
      if (!this.offer || this.delivered <= 0 || this.delivered >= this.offer.minimum) return 0;
      return this.offer.minimum - this.delivered;
    },
    total: function () { return this.pricing.grandTotal - this.credit; }
  }
};
</script>
